import { styled } from "goober";
import { formatRelativeTime } from "../lib/formatRelativeTime";
import { Dropdown } from "./Dropdown";
import { Icon } from "./Icon";
import { MetaSep } from "./MetaSeparator";
import { formatTime } from "./StepExecutions";
import { Text } from "./Text";

const Opener = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-secondary);

  &:hover {
    color: var(--text-primary);
  }
`;

export type PickableRun = {
  id: string;
  createdAt: number;
  run?: { ephemeral?: boolean | null } | null;
};

export function StepRunPicker({
  runs,
  selectedId,
  onSelect,
  placeholder = "Pick a run",
}: {
  runs: readonly PickableRun[];
  selectedId: string | null;
  onSelect: (runId: string) => void;
  placeholder?: string;
}) {
  const selected = runs.find((r) => r.id === selectedId) ?? null;
  return (
    <Dropdown
      align="bottom-left"
      minWidth={220}
      opener={
        <Opener>
          <Icon name="run" size={12} />
          <Text variant="text-small-md">
            {selected ? formatTime(selected.createdAt) : placeholder}
          </Text>
          <Icon name="chevron-down" size={12} />
        </Opener>
      }
      sections={[
        {
          items: runs.map((run) => ({
            type: "button" as const,
            key: run.id,
            selected: run.id === selectedId,
            label: formatTime(run.createdAt),
            left: (
              <Icon name={run.run?.ephemeral ? "solo-run" : "run"} size={12} />
            ),
            subtitle: (
              <Text variant="text-small" ellipsis>
                <span style={{ color: "var(--green-600)" }}>Successful</span>
                <span style={{ color: "var(--text-secondary)" }}>
                  <MetaSep />
                  {formatRelativeTime(run.createdAt)}
                </span>
              </Text>
            ),
            right:
              run.id === selectedId ? (
                <Icon name="check" size={12} color="var(--text-secondary)" />
              ) : undefined,
            onClick: () => onSelect(run.id),
          })),
        },
      ]}
    />
  );
}
